import { styled } from 'styled-components';

import SvgIcon from '@/components/SvgIcon';
import { buriedPoint } from '@/utils/buriedPoint';

const ScrollbarCustomUl = styled.ul`
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.35);
    border-radius: 19px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 19px;
  }
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.35) transparent;
`;

const GroupSendCoupon = ({ data, targetLink, onClose }) => {
  if (!data?.couponList?.length) return <></>;
  function handleOpen() {
    buriedPoint({
      ty: 'click',
      cp: 'float_adv',
      op: 'window_in_central',
      pf: 'pc',
      data: { Based_id: data?.autoSubgroupId, ck: 'open', hf: targetLink },
    });
  }

  function handleClose() {
    buriedPoint({
      ty: 'click',
      cp: 'float_adv',
      op: 'window_in_central',
      pf: 'pc',
      data: { Based_id: data?.autoSubgroupId, ck: 'close', hf: targetLink },
    });
    onClose();
  }

  const { couponList } = data;
  if (!couponList.length) return <></>;
  return (
    <section className={'absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]'}>
      <div
        className={
          'w-[237px] h-[119px] ml-[38px] translate-y-[12px]  bg-[url(//static.szlcsc.com/ecp/assets/newWeb/www/home/group/group-modal-title.png)] ' +
          'bg-no-repeat bg-[length:100%_100%]'
        }
      ></div>
      <div
        className={
          'w-[311px] px-[15px] rounded-[10px] pt-[24px] pb-[18px] bg-[url(//static.szlcsc.com/ecp/assets/newWeb/www/home/group/group-modal-bg.png)] ' +
          'bg-no-repeat bg-[length:100%_100%]'
        }
      >
        <div className={'mb-[20px] text-[#1B324F] text-[20px] font-medium text-center'}>专属优惠券</div>
        <ScrollbarCustomUl className={'max-h-[320px] overflow-y-auto overflow-x-hidden'}>
          {couponList.map((item, index) => {
            let leftDom = (
              <div className={'truncate max-w-[60px] text-[12px] font-semibold'} title={`￥${item?.couponAmount}`}>
                <span>￥</span>
                <span className={'text-[24px]'}>{item?.couponAmount}</span>
              </div>
            );
            if (item?.couponType === 'freight' && item?.isFreeExpress) {
              leftDom = <div className={'truncate max-w-[60px] text-[24px] font-semibold'}>包邮</div>;
            }
            if (item?.couponType === 'discount') {
              leftDom = (
                <div className={'font-semibold truncate max-w-[60px]'} title={`${item?.couponDiscount * 10}折`}>
                  <span className={'text-[24px] '}>{item?.couponDiscount * 10}</span>
                  <span className={'text-[12px]'}>折</span>
                </div>
              );
            }
            return (
              <li
                key={index}
                className={
                  'w-[281px] h-[92px] mb-[10px] bg-[url(//static.szlcsc.com/ecp/assets/newWeb/www/home/group/group-modal-coupon-bg.png)] ' +
                  'bg-no-repeat bg-[length:100%_100%]'
                }
              >
                <div className={'flex h-[92px]'}>
                  <div className={'w-[72px] justify-center items-center flex flex-col text-[#FF4434] '}>
                    {leftDom}
                    <div
                      className={'text-[12px] truncate max-w-[60px] font-normal'}
                      title={`满${item?.minOrderMoney}可用`}
                    >
                      满{item?.minOrderMoney}可用
                    </div>
                  </div>
                  <div className={'flex-1 justify-center items-center flex flex-col'}>
                    <div
                      className={'text-[14px] w-[155px] text-[#000000] font-medium leading-[20px] mb-[2px] truncate'}
                      title={item?.couponName}
                    >
                      {item?.couponName}
                    </div>
                    <div className={'font-normal w-[155px]  text-[10px] text-[#666666] leading-[14px]'}>
                      有效期至：{item?.couponValidEndTime}
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ScrollbarCustomUl>
        <div className={'flex justify-center mt-[15px]'}>
          <a
            href={targetLink}
            rel="nofollow"
            onClick={handleOpen}
            target="_blank"
            className={
              'w-[165px] h-[51px] flex items-center justify-center text-[18px] cursor-pointer font-semibold text-white bg-[url(//static.szlcsc.com/ecp/assets/newWeb/www/home/group/group-modal-btn-bg.png)] ' +
              'bg-no-repeat bg-[length:100%_100%]'
            }
          >
            立即查看
          </a>
        </div>
      </div>
      <div className={'flex justify-center mt-[15px]'}>
        <SvgIcon
          app="common"
          iconName={'group-modal-close'}
          onClick={handleClose}
          className={'cursor-pointer h-[28px] w-[28px]'}
        />
      </div>
    </section>
  );
};

export default GroupSendCoupon;
